import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { init } from 'artlabs-experience';

import { useQuery } from '../utils/helpers';

import Footer from '../components/Footer';
import ImportArtlabsViewer from 'components/ImportArtlabsViewer';

function Product() {
  const { slug } = useParams();
  let query = useQuery();

  const token = query.get('token');
  const arButton = query.get('arButton');
  const wireframe = query.get('wireframe');

  let productRef = useRef(null);

  useEffect(() => {
    if (token) {
      init({
        token,
      });
    }
  }, [token]);

  return (
    <>
      {token && <ImportArtlabsViewer meshkraftKey={token} />}

      <Footer slug={slug} arButton={arButton} />
      <Main sku={slug} product={productRef.current} />
    </>
  );
}

const Main = ({ sku, product }) => {
  const [height, setHeight] = useState('90vh');
  const { userAgent } = navigator;

  useEffect(() => {
    // grab the version number from the string
    const regex = /Version\/(.*?) Safari\//;
    const matches = userAgent.match(regex);

    // for Safari version < 15
    // change the height of the viewer
    if (
      navigator.userAgent.indexOf('Safari') !== -1 &&
      matches?.length &&
      Number(matches[1]) < 15
    ) {
      setHeight('70vh');
    }
  }, [userAgent]);

  let query = useQuery();
  const disableCart = query.get('disableCart');
  const wireframe = query.get('wireframe');
  const dimensions = query.get('dimensions');

  let viewerConfig = `{"ar-modes": "scene-viewer webxr quick-look fallback", "ar-scale": "auto", "max-field-of-view": "90deg", "min-field-of-view": "30deg"}`;
  let viewerProps = {};
  if (wireframe) viewerProps['show-wireframe'] = true;
  if (dimensions) viewerProps['show-dimensions'] = true;

  return (
    <div
      style={{
        width: '100%',
        height: 'clamp(0px, calc(100vh - 82.3px), 100vh)',
        backgroundColor: '#E7E7E7',
      }}
    >
      <artlabs-viewer
        height={height}
        sku={sku}
        show-banner={!disableCart}
        config={viewerConfig}
        show-dimensions
        show-annotations
        {...viewerProps}
      />
    </div>
  );
};

export default Product;
